import React from 'react'
import { Column } from 'primereact/column'
import NumericBodyTemplate from './NumericBodyTemplate'
import MinutesEditor from './MinutesEditor'
import { createColumnAttributes } from '../utils/createColumnAttributes'
import { getRowClassName } from '../utils/getRowClassName'

const ContributionMinutesColumn = ({ title, mapsToField, filter, sortable, editable, isFieldChanged, isFieldChangedOverride, validationErrors, originalData, episodeDuration, updateRowField, editorCallbacksRef, toastRef, dataKey }) => {
    const { filterAttributes, sortAttributes, checkFieldChanged } = createColumnAttributes({
        filter,
        title,
        sortable,
        editable,
        isFieldChangedOverride,
        defaultIsFieldChanged: isFieldChanged,
        mapsToField,
        originalData
    })

    return (
        <Column
            {...sortAttributes}
            key={mapsToField}
            field={mapsToField}
            header={title}
            dataType="numeric"
            body={(rowData) => (
                <span className={getRowClassName(checkFieldChanged, rowData)}>
                    <NumericBodyTemplate rowData={rowData} field={mapsToField} decimalPlaces={2} />
                </span>
            )}
            editor={editable ? (options) => <MinutesEditor options={options} validationErrors={validationErrors} episodeDuration={episodeDuration} editorCallbacksRef={editorCallbacksRef} toastRef={toastRef} dataKey={dataKey} /> : null}
            {...filterAttributes}/>
    )
}

export default ContributionMinutesColumn
